module.exports = "<p>refresh works!</p>\n"